import { ResponseError } from 'models';
import { TFunction } from 'i18next';

export function getErrorText(error: ResponseError | undefined, t: TFunction) {
	if (error) {
		return t(error.error_code.toLowerCase());
	}
}
